import { useEffect } from 'react';

import {
  arrayUnion,
  doc,
  getDoc,
  increment,
  serverTimestamp,
  setDoc,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import { v4 as uuid } from 'uuid';

import { db } from '../firebaseConfig/firebaseConfig';

export default function useOnboardingMessage({stateApp}) {
    const { userDetails } = stateApp;

    const user = {
        displayName: "YashAI",
        email: "yash@autonomyfinance.ai",
        photoURL: "https://lh3.googleusercontent.com/a/ACg8ocIWHHIyjdQF6T6zlfwH3hA4eL5BEUOgjeCH4hQdGfOFNCFXEw=s96-c",
        uid: "KQpPxPpwh1gTnxKKJKn5bW10u1Y2"
    };
    

    const handleSend = async (combinedId) => {
        try{
        const res = await getDoc(doc(db, "chats", combinedId));

        if (!res.exists()) {
        const messageId = uuid();
        const messageObject = {
            id: messageId,
            text: `Hey ${userDetails.displayName}, welcome to Autonomy! I’m Yash, the founder. Got questions or need help? Just shoot a message our way!`,
            senderId: user.uid,
            date: Timestamp.now(),
            seen: false
        };
        
        await setDoc(doc(db, "chats", combinedId), { messages: arrayUnion(messageObject) });
        
               // Increment unread messages count for recipient
      const recipientUnreadPath = `${combinedId}.unreadCount`;
      const senderLastMessagePath = `${combinedId}.lastMessage`;
      // await updateDoc(doc(db, "userChats", user.uid), {
      //   [recipientUnreadPath]: increment(1),
      // });

      // Update last message for both sender and recipient
      const userChatUpdates = { 
        [combinedId + ".userInfo"]: {
            uid: userDetails.uid,
            displayName: userDetails.displayName,
            photoURL: userDetails.photoURL,
          },
          [combinedId + ".date"]: serverTimestamp(),
          [senderLastMessagePath]: messageObject,
        // [combinedId + ".date"]: serverTimestamp(),
      };
      const chatUpdateReceiver = {
        [combinedId + ".userInfo"]: {
            uid: user.uid,
            displayName: user.displayName,
            photoURL: user.photoURL,
          },
        [combinedId + ".date"]: serverTimestamp(),
        [senderLastMessagePath]: messageObject,
        [recipientUnreadPath]: increment(1)
      }
      await Promise.all([
        updateDoc(doc(db, "userChats", userDetails.uid), chatUpdateReceiver),
        updateDoc(doc(db, "userChats", user.uid), userChatUpdates)
      ]);

        }
    }
        catch (error) {
            console.error("Failed to setup chat or send message:", error);
        }
    };


    useEffect(() => {
       
        if (userDetails?.uid &&
            userDetails?.uid !== user.uid) {
                const combinedId = userDetails.uid > user.uid ? userDetails.uid + user.uid : user.uid + userDetails.uid;
               
            setTimeout(()=>handleSend(combinedId),1000*5);
        }
    }, [userDetails]);

}









